<template>
  <div>
    <button @click="isOpenModal = true" class="btn-info-button h-8">
      Copy from unificado
    </button>
    <BaseModal class="copy-modal" v-model="isOpenModal">
      <div class="header">
        <div class="info">Copy from unificado {{ unified }}</div>
      </div>
      <div class="content" v-if="loading">
        <BaseSmallSpinner />
      </div>
      <div class="content copy" v-else>
        Get Applications from Unificado code
        <input
          type="text"
          class="regular clear"
          name="newUnified"
          v-model="unificadoToCopy"
        />
        <button @click="confirmCopyFromUnificado" class="btn-dark-button">
          Get Applications
        </button>
      </div>
    </BaseModal>
  </div>
</template>
<script>
import httpStore from "@/api/httpStore.js";

export default {
  props: {
    unified: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isOpenModal: false,
      unificadoToCopy: "",
      loading: false
    };
  },
  methods: {
    confirmCopyFromUnificado() {
      this.responseMessage = null;
      this.loading = true;
      if (this.unificadoToCopy != "") {
        httpStore
          .post("applications/copy_from_unificado", {
            fromUnificado: this.unificadoToCopy,
            toUnificado: this.unified
          })
          .then(response => {
            this.responseStatus = response.data.responseStatus;
            this.responseMessage = response.data.responseMessage;
            if (this.responseStatus) {
              this.$emit("added");
            }
            this.isOpenModal = false;
            this.loading = false;
            this.$toast.open({
              message: this.responseMessage,
              type: "success",
              position: "top-right"
            });
          })
          .catch(error => {
            console.log("Error! Could not reach the API. " + error);
            this.loading = false;
            this.responseMessage = "Connection Error please try again Later";
            this.$toast.open({
              message:
                "Error copying applications, please contact your system administrator",
              type: "error",
              position: "top-right"
            });
          });
      } else {
        this.responseStatus = false;
        this.loading = false;
        this.responseMessage = "Incomplete Info";
      }
    }
  }
};
</script>
<style lang="scss">
.copy-modal {
  &:focus {
    outline: none;
  }
  &.modal {
    padding-top: 40px;
    .modal-content {
      height: 400px !important;
      width: 500px !important;
      padding: 0px;
      .content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100%;
        align-content: center;
        input {
          text-align: center;
          margin-top: 20px;
        }
        button {
          width: auto;
          margin-top: 20px;
        }
      }
      @media screen and (max-width: 1600px) {
        width: 500px !important;
      }
    }
    .modal-bg {
      height: calc(100% - 40px);
    }
  }
}
</style>
